const {Component} = require("react");
const assign = require("object-assign");

class Numeric extends Component {

	get name() {
		return this.props.name;
	}

	get value() {
		return this.inputElement.value;
	}

	get elementProps() {
		return assign({}, this.props, {
			onInput: this.onInput
		});
	}

	onInput = (e) => {
		const initialValue = e.target.value;
		e.target.value = initialValue.replace(/[^0-9]/g, "");

		if ((initialValue === e.target.value) && (typeof this.props.onInput === "function")) {
			this.props.onInput(e);
		}
	};

	render() {
		const props = this.elementProps;

		return (
			<input ref={el => this.inputElement = el} type="text" pattern="\d*" {...props} />
		);
	}

}

module.exports = Numeric;